module.exports = __webpack_public_path__ + "img/domain14-icon-3.b1a3fa38.webp";